import { inject, Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'

import { AuthError } from '@core/auth/models/auth.models'
import { CoreAuthService } from '@core/auth/services/core-auth-service'
import { Store } from '@ngrx/store'
import { goToPage } from '@core/ngrx-router/state/actions/ngrx-router.actions'

@Injectable({
  providedIn: 'root'
})
export class UserDisallowedGuard {
  private readonly _store: Store = inject(Store)
  private readonly _ionicAuth: CoreAuthService = inject(CoreAuthService)

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this._ionicAuth.events$.pipe(
      tap((action) => action.error !== AuthError.UserDisallowed && this._store.dispatch(goToPage({}))),
      map((error) => !!error)
    )
  }
}
